import { graphqlApi } from '~/shared/store/api-services/graphql-api';

export const callApi = (endpoint: string, args: any) => {
  return (graphqlApi.endpoints as any)[endpoint].initiate(args);
};
